import React, { FC } from "react";
import { styles, getThemedStyles } from "./LockedImagePost.styles";
import LockOutlineIcon from "@mui/icons-material/LockOutlined";
import { classNames } from "../../../../../../../utils/common/styling";
import { useCreatorThemeContext } from "../../../../../../../features/Common/modules/Theme/CreatorThemeContext";
import { DEFAULT_PAID_POST_CTA_LABEL } from "../UpgradeButton/UpgradeButton";

export const LockedImagePost: FC<{
  onClick: () => void;
  ctaLabel?: string;
}> = ({ onClick, ctaLabel = DEFAULT_PAID_POST_CTA_LABEL }) => {
  const theme = useCreatorThemeContext();
  const themedStyles = getThemedStyles({ theme });
  return (
    <div className={styles.container}>
      <img
        className={styles.lockedImg}
        src="https://i.postimg.cc/WbRDDSqd/image-18.png" // Will replace with S3
      />
      <div className={styles.innerContainer}>
        <img
          className={styles.paidIcon}
          src="https://i.postimg.cc/0yy9rJn6/image-19.png" // Will replace with S3
        />
        <div className={styles.paidText}>This is a paid post</div>
        <div className={styles.paidDesc}>
          You&apos;re missing out on premium insights & perks! Pay to unlock the
          contents of this post
        </div>
        <div
          className={classNames(
            styles.upgradeContainer,
            themedStyles.upgradeContainer,
          )}
          onClick={onClick}
        >
          <LockOutlineIcon fontSize="small" />
          <div className={styles.upgradeText}>{ctaLabel}</div>
        </div>
      </div>
    </div>
  );
};
